import { AsyncModule } from "vuex-async-mutations";
import { Material, MaterialType } from "@/types";

interface MaterialItemState {
  items: Material[];
}

const factory = (): MaterialItemState => ({ items: [] });

export const module = (type: MaterialType): AsyncModule<MaterialItemState, any> => ({
  namespaced: true,

  async: true,

  state: factory,

  getters: {
    ["findItem"](state) {
      return (id: number) => state.items.find(item => item.id === id);
    },

    ["findItemBySn"](state) {
      return (sn: string) =>
        state.items.find(
          item =>
            item?.patterns?.some(p => sn && sn.match(new RegExp(p))) ||
            item?.types?.some(type => type.patterns?.some(p => sn && sn.match(new RegExp(p))))
        );
    },

    ["findItemsBySn"](state) {
      return (sn: string) =>
        state.items.filter(
          item =>
            item.patterns?.some(p => sn && sn.match(new RegExp(p))) ||
            item.types?.some(type => type.patterns?.some(p => sn && sn.match(new RegExp(p))))
        );
    },

    ["hasBreaker"](state) {
      return (sn: string) => {
        let hasBreaker = true;
        const item = state.items.find(
          item =>
            item?.patterns?.some(p => sn && sn.match(new RegExp(p))) ||
            item?.types?.some(type => type.patterns?.some(p => sn && sn.match(new RegExp(p))))
        );

        if (item?.types) {
          const matchingType = item.types.find(type =>
            type.patterns.some(pattern => sn.match(new RegExp(pattern)))
          );
          if (matchingType) {
            hasBreaker = matchingType.hasBreaker !== false;
          }
        }

        return hasBreaker;
      };
    }
  },

  mutations: {
    ["reset"](state) {
      Object.assign(state, factory());
    }
  },

  actionsAsync: {
    ["fetch"]: {
      handler({ commitAsync }) {
        return commitAsync(this.$axios.$get(`/materials/${type}`));
      },

      resolved(state, items: Material[]) {
        state.items = items;
      }
    },
    ["fetch:configDefault"]: {
      handler(context, { id, amount }: { id: number; amount: number }) {
        return this.$axios.get(`/materials/inverter-configurations/${id}/panels/${amount}`);
      }
    }
  }
});

export default module;
